import { Star, StarOff } from 'lucide-react';
import { memo } from 'react';
import { useTranslation } from "react-i18next";

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { accessFormPopupActions } from '@common-reducers/AccessFormPopupReducer';
import { contactsLabelsSelectOneObjectByQuery, labelSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks";
import { selectUserObject } from '@common-reducers/UserSelectors';
import { toggleChatLabelThunk } from '@common-reducers/labels-reducer/labels-thunks';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { namespace } from "@common-config/constants";

type Props = {
    waChatId: string,
    size?: number
}

export default memo(function StarButton({ waChatId, size }: Props) {
    const { t } = useTranslation(namespace);
    const dispatch = useAppDispatch()
    const authUser = useAppSelector(selectUserObject);

    const label = useAppSelector(state => {
        return labelSelectOneObjectByQuery(state.DBLabelReducer, {
            type: 'starred'
        })
    })

    const contactLabel = useAppSelector((state) => contactsLabelsSelectOneObjectByQuery(state.DBContactsLabelsReducer, {
        labelId: label?._id,
        waChatId
    }))

    // Debug logging
    // console.log(`[StarButton] waChatId: ${waChatId}, labelId: ${label?._id}, hasContactLabel: ${!!contactLabel}`);

    function starContact(e: React.MouseEvent) {
        e.preventDefault();
        e.stopPropagation();
        dispatch(toggleChatLabelThunk({
            waChatId: waChatId,
            labelId: label?._id || '',
        }))
    }


    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        className={`group p-1 rounded transition-colors cursor-pointer ${contactLabel ? "text-yellow-500 hover:text-gray-500" : "text-gray-500 hover:text-yellow-500"}`}
                        onClick={starContact}
                    >
                        {contactLabel ? (
                            <>
                                <Star size={size || 18} className="currentColor group-hover:hidden" strokeWidth={2} />
                                <StarOff size={size || 18} className="currentColor hidden group-hover:block" strokeWidth={2} />
                            </>
                        ) : (
                            <Star size={size || 18} className="currentColor" strokeWidth={2} />
                        )}
                    </button>
                </TooltipTrigger>
                <TooltipContent side="bottom">
                    <p>{contactLabel ? t('labels.removeStar') : t('labels.star')}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
})
